<template>
  <div
    id="SearchOverlayMobile"
    class="pure-form"
  >
    <SearchInputField
      :focus="focus"
      @search-blur="$emit('search-blur')"
      @search-triggered="runSearch"
      @searchTerm="getOverlay"
      :is-loading="isLoading"
      :is-inch-search="isInchSearch"
      @changeUnit="handleChange"
    />
    <div
      v-if="searchTermResult?.customerSuggestions?.length > 0"
      class="overlay__search-suggestions"
    >
      <suggestions-grid
        :suggestions="searchTermResult.customerSuggestions"
        :max-suggestions="4"
        :enable-pagination="false"
        :show-all-results="true"
        :search-term="searchTerm"
        @openBuyBoxSku="openBuyBoxSku"
        @show-all-results="runSearch"
      />
    </div>
    <div
      v-if="searchTermResult && searchTermResult.searchResults && searchTermResult.searchResults.length"
      class="search-overlay__content"
    >
      <div class="overlay__header">
        <div>
          <span v-tv:searchResults="'itemMatches'" />
          <span
            v-text="searchTermResult.count"
          />
        </div>
        <nuxt-link
          :to="resultPathWithCategory"
          class="show-all-results"
          @click="closeOverlay"
        >
          {{ i18n.tv('ShowAllResults','searchResults') }}
          <ArrowForwardIcon class="forward-icon" />
        </nuxt-link>
      </div>
      <NewSearchOverlayResults
        :products="mappedProducts"
        :l2categories="l2categories"
        :categories="categories"
        :search-term="searchTerm"
        :is-any-search="isAnySearch"
        @close-overlay="$emit('close-overlay')"
        @openBuyBox="openBuyBox"
        @clickItem="clickItem"
      />
    </div>
    <div
      v-else-if="searchTermResult && searchTermResult.searchResults && searchTermResult.searchResults.length === 0 && !searchTermResult?.customerSuggestions?.length > 0"
      class="search-overlay__content"
    >
      <div
        class="h5"
        v-tv:searchResults="'NoProducts'"
      />
    </div>
    <div
      v-else-if="searchTermResult && !searchTermResult?.customerSuggestions?.length > 0"
      class="overlay__skeleton"
    >
      <SearchSkeleton
        @close="closeOverlay()"
        :mobile="true"
      />
    </div>
  </div>
</template>

<script>
import NewSearchOverlayResults from '~/components/search/NewSearchOverlayResults.vue'
import SearchInputField from '~/components/search/SearchInputField.vue'
import {getMappedProducts} from '~/assets/js/utils/product_attributes_mapping'
import SearchSkeleton from '~/components/skeletons/SearchSkeleton.vue'
import SuggestionsGrid from '~/components/search/SuggestionsGrid.vue'
import useI18nExtended from '~/composables/usei18nExtended'
import ArrowForwardIcon from '~/assets/icons/md_arrow_forward.svg?component'

export default {
  components: {
    ArrowForwardIcon,
    NewSearchOverlayResults,
    SearchInputField,
    SearchSkeleton,
    SuggestionsGrid
  },
  data() {
    return {i18n: useI18nExtended()}
  },
  props: {
    focus: {
      type: Boolean
    },
    searchTerm: {
      type: String,
      default() {
        return ''
      }
    },
    l2categories: {
      type: Array,
      default () {
        return []
      }
    },
    categories: {
      type: Array,
      default () {
        return []
      }
    },
    searchTermResult: {
      type: Object,
      default () {
        return {}
      }
    },
    isLoading: {
      type: Boolean,
      default () {
        return false
      }
    },
    isInchSearch: {
      type: Boolean,
      default () {
        return false
      }
    },
    isAnySearch: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  methods: {
    closeOverlay() {
      this.$emit('close-overlay')
    },
    runSearch() {
      this.$emit('close-overlay')
    },
    getOverlay(value) {
      this.$emit('search-term', value)
    },
    openBuyBox(product) {
      this.$emit('openBuyBox', product)
    },
    openBuyBoxSku(sku, index) {
      this.$searchInsights?.trackEvent({
        name: 'ClickSuggest', properties: {
          searchServiceName: this.searchTermResult?.azureSearchTelemetry?.searchServiceName,
          searchId: this.searchTermResult?.azureSearchTelemetry?.searchId,
          clickedDocId: sku,
          sku: sku,
          rank: index
        }
      })
      this.$emit('openBuyBoxSku', sku)
    },
    handleChange() {
      this.$emit('changeUnit')
    },
    clickItem(sku, rank) {
      this.$emit('clickItem', sku, rank)
    }
  },
  computed: {
    mappedProducts() {
      return getMappedProducts(this.searchTermResult)
    },
    resultPath() {
      const path = this.localePath({name: 'searchResults'})
      return path + '?query=' + encodeURIComponent(this.searchTerm)
    },
    resultPathWithCategory() {
      let resultingPath = this.resultPath
      if (this.l2categories?.length === 1 &&
          this.searchTermResult?.count === this.l2categories[0]?.hitCount) {
        resultingPath = `${resultingPath}&PrimaryL2Category=${this.l2categories[0].categoryName}`
      }

      return resultingPath
    }
  }
}
</script>

<style lang="scss">
[id='SearchOverlayMobile'] {
  margin-top: -.9rem;
  position: relative;
  justify-content: center;
  align-items: center;

  .overlay__search-suggestions {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    margin-bottom: 1rem;
    margin-top: 1rem;
  }

  .search-overlay__content {
    margin-top: 1rem;

    .h5 {
      margin-bottom: .5rem;
      font-size: 1rem;
    }
  }
}

.popup__wrapper:has(#SearchOverlayMobile) {
  width: 100%;
}
</style>
